import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownDirective } from 'src/app/directives/dropdown.directive';
import { OnlyInStock } from 'src/app/models/enums/OnlyInStock.enum';
import { Filter } from 'src/app/models/types/Filters.type';
import { RulesService } from 'src/app/services/api/rules.service';
import { AuthService } from 'src/app/services/auth.service';
import { FiltersService } from 'src/app/services/filters.service';

@Component({
  selector: 'app-only-in-stock',
  imports: [TranslateModule, DropdownDirective],
  templateUrl: './only-in-stock.component.html',
  styleUrl: './only-in-stock.component.scss'
})
export class OnlyInStockComponent {

  @Input() withPezzotto: boolean = false;

  // public get areAllStockViewOptionsVisible(): boolean {
  //   return Boolean(this.authService.user?.isUserStore );
  // }

  public get areAllStockViewOptionsVisible(): boolean {
    return Boolean(this.authService.user?.isUserStore && !(this.rulesService.isHJorHEWrule() && this.withPezzotto));
  }

  constructor(
    public authService: AuthService,
    public filtersService: FiltersService,
    private readonly translateService: TranslateService,
    private readonly rulesService: RulesService,
  ) { }

  getOptionLabel(opt: Filter): string {
    if (!opt) return '';

    let optionLabel = '';

    if (opt.field === "OnlyInStock") {
      if (opt.values[0] === "true") {
        optionLabel = OnlyInStock.CountryRegionStock;
      } else {
        optionLabel = OnlyInStock.ViewAll;
      }
    } else {
      optionLabel = OnlyInStock.MyStoreStock;
    }

    return this.translateService.instant(optionLabel);
  }

  selectOption(opt: Filter) {
    this.filtersService.setOnlyInStockFilter(opt);
    this.filtersService.submit()
  }

}
